module.exports = __webpack_public_path__ + "img/receipt-minus.04363959.svg";